export default {
  profile_view: {
    "facts_title": "At a glance",
    "open_gallery": "View photos: {name}",
    "view_gallery": "View all",
    "open_photo": "Open photo {index}: {name}",
    "photo_alt": "{name} - photo {index}",
    "photo_position": "Photo {current} of {total}",
    "close_gallery": "Close gallery",
    "previous_photo": "Previous photo",
    "next_photo": "Next photo",
    "back_to_profile": "Back to profile",
    "photo_error": "This photo could not be loaded. Please try again shortly.",
    "about_empty_title": "Not every story starts with a bio.",
    "about_empty_description": "{name} has not added a bio yet. Sometimes a few words in a conversation say more than a whole profile.",
    "details_empty_title": "These details have not been added to the profile yet. Discover more in conversation.",
    "photos_empty_description": "No photos yet - perhaps in time."
},
  consent: {
    "title": "Your privacy on JaTy",
    "description": "Essential cookies support sign-in, security and your choices. With your consent, Google Analytics measures website use and JaTy remembers your registration source. You can decline and continue using the service.",
    "necessary": "Essential – always active",
    "necessary_description": "Your session, security, selected language and saved settings. These work independently of analytics consent.",
    "analytics": "Analytics",
    "analytics_description": "Google Analytics and remembering the campaign and first page visited when you register. Declining keeps your account working but prevents us from saving this acquisition information.",
    "simple_analytics": "Aggregate Simple Analytics statistics use no cookies and respect Do Not Track. We do not link them to your account.",
    "accept": "Accept all",
    "reject": "Essential only",
    "settings": "Cookie settings",
    "save": "Save choice",
    "close": "Close settings",
    "storage_unavailable": "Your browser could not save your choice. It applies on this page; we will ask again on your next visit."
},
  login: 'Log in',
  language_picker: 'Choose language',
  login_do: 'Log in',
  logout: 'Log out',
  or: 'or',
  terms: 'Terms and conditions',
  cookies_policy: 'Cookies policy',
  privacy_policy: 'Privacy policy',
  email: 'E-mail',
  password: 'Password',
  success: 'Made it!',
  comeback: 'Back',
  to: 'to',
  is: 'do',
  login_to: 'log in',
  something_wrong: 'Sorry, something went wrong',
  ask_for_another_email: 'Request a new email',
  send: 'Send',
  find_love_online: 'Find love online',
  fast_login: 'Quick login',
  hi: 'Hello',
  woman: 'Woman',
  man: 'Male',
  continue: 'Next',
  cancel: 'Cancel',
  save_changes: 'Save changes',
  premium_for_month: 'You are premium for the next month!',
  see_partners_suggestions: 'See partner suggestions',
  kilometer: 'km',
  from: 'from',
  reset_do: 'Reset',
  parameters: 'Parameters',
  change_do: 'Change',
  city: 'City',
  distance: 'Distance',
  save_parameters: 'Save parameters',
  propositions: 'Suggestions',
  hearts: 'Hearts',
  your_pairs: 'Your matches',
  your_profile: 'Your profile',
  check_profile: 'View profile',
  problem: 'Problem',
  are_you_sure: 'Are you sure?',
  change_order: 'Save order',
  yes_delete: 'Yes, delete',
  hide_menu: 'Hide menu',
  show_menu: 'Show menu',
  month: 'month',
  three_months: 'months',
  twelve_months: 'months',
  go_back_home: 'Back to home page',
  see_more: 'See more',
  and: 'and',
  close: 'Close',
  get_now: 'Get it now',
  buy_now: 'Buy Now',
  you_are_pair_with: 'You matched with',
  you_are_offline: 'It looks like you are offline. <a href="/">Reload page</a>',
  close_this_window: 'Close this window',
  not_now: 'Not now',
  not_found: 'Not found',
  something_went_wrong: 'Something went wrong :(',
  homepage: 'Homepage',
  account: {
    confirmed: 'Your account has been confirmed! You can log in! ',
    confirmed_already: 'Your account has already been confirmed',
    wrong_password: 'Wrong login or password',
    cant_login_now: 'Unable to login now',
    login: 'Log in',
    login_slogan: 'Good to see you again. See what\'s new.',
    no_account: 'You don\'t have an account?',
    your: 'Your account',
    password: {
      change: 'Change password',
      forgot: 'Forgot your password?',
      remind: 'Reset your password',
      remind_now: 'Send reset link',
      change_now: 'Change password',
      changed_successfully: 'Successful password change! You can log in ',
      check_your_email: 'Check your email',
      to_reset_password: 'to recover your password',
      current: 'Current password',
      new: 'New password',
      repeat_new: 'Repeat new password',
      change_success: 'Password changed!',
    },
    lang_choose: {
      is: 'Language selection',
    },
    notification_preferences: {
      is: 'Notification preferences',
      email_notification: 'Email notifications',
      about_hearts: 'Receive notifications about hearts you receive',
      about_pairs: 'Receive notifications about new matches',
      about_payments: 'Receive payment status notifications',
      about_messages: 'Receive notifications of new messages',
      push_status_text: 'Status of notifications on this device and in this browser',
      push_not_yet_given: 'not yet granted',
      push_given: 'granted',
      push_not_given: 'not granted'
    }
  },
  web_push: {
    on: 'Enable notifications',
    off: 'Notifications disabled',
    we_cant_turn_on: 'We cannot turn on notifications',
    manual_turn_on_help: 'To enable notifications, you must go to your browser settings and grant notification permissions for our website yourself.',
    turn_on_description: 'Enable notifications for new <br><strong>hearts</strong>, <strong>matches</strong>, <strong>messages</strong>?',
    yes_turn_on: 'Yes, enable'
  },
  chat: {
    delivery_failed: 'Message was not sent',
    delivery_unconfirmed: 'Sending not confirmed',
    retry: 'Retry',
    search: 'search ...',
    no_new: 'You don\'t have any chats',
    lets_talk: 'Let\'s talk!',
    choose_person: 'Choose the person you want to chat with.',
    no_more_messages: 'No more messages',
    load_more_messages: 'Load more messages',
    send: 'Send',
    do_you_want_to_dislike: 'Do you want to dismiss the message?',
    do_you_want_to_dislike_text: 'If you reject the message, further communication with the user will not be possible',
    yes_dislike: 'Yes, decline',
    new_messages: 'new messages',
    new_message: 'new message',
    read: 'Read'
  },
  register: {
    do: 'Register',
    on_jaty: 'Registration on JaTy',
    description_text: 'Show who you are. The rest starts with a conversation.',
    you_got_free_month: 'You got a <b>free</b>month from us!',
    social_login_error: 'Unable to login with Facebook. Probably your profile does not provide an email address.',
    or_register: 'or register',
    first_name: 'Name / nickname',
    accept_policy: 'I accept the <a href="{privacy_url}" target="_blank" rel="nofollow">privacy policy</a> and <a href="{terms_url}" target="_blank" rel="nofollow">terms and conditions</a>. '
  },
  contact: {
    do: 'Contact',
    with_us: 'Contact JaTy',
    with_us_do: 'Contact us.',
    slogan: 'Have a question? We\'re happy to help.',
    topic: 'Subject',
    describe: 'Describe your problem',
    thanks: 'Thank you for submitting the form. We will reply as soon as possible!',
  },
  facebook: {
    login: 'Login with Facebook'
  },
  faq: {
    is: 'FAQ',
    how_heart_works: 'How does "heart" work?',
    how_heart_works_answer: 'A heart is a simple way to let someone know you would like to get to know them better. When you send one, the other person will be notified of your interest. If they send a heart back, you will automatically become a match and see each other in “Your matches”.',
    heart_flow_you: 'You',
    heart_flow_other_person: 'The other person',
    heart_flow_mutual: 'You both send a heart',
    heart_flow_pair: 'You can start chatting',
    make_attractive: 'How can I improve my profile on JaTy?',
    make_attractive_answer_first_part: 'It is worth completing your profile with photos and a little information about yourself. It helps people understand who you are and what you are looking for, while making the suggestions you see more relevant to you.',
    make_attractive_answer_second_part: 'Your photos matter too. Choose clear pictures where you can be seen easily and which genuinely show you. Graphics, avatars, and random images rarely make it easier to start a conversation.',
    inappropriate_content: 'Someone posted inappropriate content!',
    inappropriate_content_answer_first_part: 'On pressing the icon',
    inappropriate_content_answer_second_part: 'on a profile or user card, you can submit a report. We will review it as soon as possible and take the appropriate action. We want JaTy to be a place where everyone can feel comfortable and safe.',
    user_blocking: 'How does user blocking work?',
    user_blocking_answer: 'Once you block someone, they will no longer be able to message you or view your profile. You will not see them in suggestions or search results either. It is a discreet option when you do not want any further contact with someone.',
    no_answer: 'Didn\'t find the answer?',
    no_answer_answer: 'Send us a message using the contact form. Briefly describe what you need help with, and we will do our best to respond as soon as possible.',
  },
  welcome: {
    incentive: 'Complete as much information as possible in your profile to help us find the best people suggestions for you',
    sex: 'Your gender',
    looking_for_women: 'Women',
    looking_for_men: 'Men',
    looking_for: 'I\'m looking for',
    your_city: 'Your city',
    your_year: 'Your year',
    preferred_partner_age: 'I am looking for age partners',
    about_title: 'Write something about yourself',
    about_text: `
                <p class="mb-6">Let other people get to know you better. Write something about yourself in a few words or sentences.</p>
                <p>You can write:</p>
                <ul class="mb-6 dotted">
                    <li>what kind of person you are</li>
                    <li>what do you do and what are your hobbies</li>
                    <li>what kind of person are you looking for and what are your intentions,</li>
                    <li>are you out of words? Insert the emoji 😉</li>
                </ul>`,
    about_me: 'About me',
    smile: 'Smile!',
    images_text: `Upload your best photos to impress your profile visitors.`,
    use_face_image: 'Select a photo that shows your face,',
    max_size: 'use photos in jpg or png format up to 8MB,',
    use_your_images: 'don\'t use someone else\'s photos,',
    use_appropriate_images: 'avoid uploading offensive, nude photos.',
    images_drop: `
                <p class="is-hidden-desktop-only is-hidden-touch">
                    Click here or drag photos from your computer.
                </p>
                <p class="is-visible-desktop is-hidden-widescreen">Click here to add photos.</p>
                <p class="m-0">
                    You can change the order of the photos.
                </p>`,
    max_images: 'Maximum number of photos is 8',
    image_required: 'Photo upload is required.',
    image_from_fb: 'We downloaded your photos from Facebook\'a',
    main_after_text: 'Main photo',
    skip_this_step: 'Skip this step',
    you_can_add_images_later: 'You can add photos later from the profile editing level',
    confirm_skipping: 'Yes, go ahead',
  },
  emoji_picker: {
    most_used: 'Most used',
    people: 'People',
    nature: 'Nature',
    objects: 'Objects',
    places: 'Places',
    symbols: 'Symbols',
  },
  help: {
    is: 'Help',
    and_contact: 'Help and contact',
    center: 'Help Center',
    faq: 'FAQ',
  },
  users: {
    send_heart: 'Send a heart',
    skip_person: 'Skip person',
    no_description: 'It is quiet here for now. Maybe a few words will appear here in time.',
    reaction_hint_title: 'Like {name}? Send a heart!',
    reaction_hint: 'Mutual hearts unlock the chat.',
    discovery_guide: {
      female_title: 'Choose your way',
      female_story: 'If someone catches your interest, send a heart and see if the feeling is mutual.',
      male_title: 'The first step is simple',
      male_story: 'If someone catches your interest, send a heart and see if the feeling is mutual.',
      instructions: 'How reactions on cards work',
      heart_action: 'Show your interest.',
      heart_description: 'Mutual hearts unlock the chat.',
      skip_action: 'Ignore.',
      skip_description: 'Hide this suggestion for a while.',
    },
    discovery_end: {
      eyebrow: 'This is not the end of the story',
      title_start: 'Choose',
      title_connector: 'or',
      title_emphasis: 'for each person',
      title_end: ', and more people will appear here soon',
      heart_label: 'heart',
      skip_label: 'cross',
      story: 'Every decision makes room for new suggestions.\nWho knows - one heart might open the door to your first conversation.',
      action: 'Finish choosing',
      technical: 'A mutual heart will open the chat automatically.',
    },
    more_actions: 'More actions for {name}\'s profile',
    first_heart: {
      title_female_1: '{name} does not know yet that you want to meet her',
      status_female_1: 'Sometimes a good conversation starts with a small sign.',
      title_female_2: 'Maybe {name} is waiting for an interesting conversation?',
      status_female_2: 'Let her know that her profile caught your attention.',
      title_female_3: 'Curious what {name} is like on the other side of the screen?',
      status_female_3: 'The first step does not need to be difficult.',
      title_male_1: '{name} does not know yet that you want to meet him',
      status_male_1: 'Sometimes a good conversation starts with a small sign.',
      title_male_2: 'Maybe {name} is waiting for an interesting conversation?',
      status_male_2: 'Let him know that his profile caught your attention.',
      title_male_3: 'Curious what {name} is like on the other side of the screen?',
      status_male_3: 'The first step does not need to be difficult.',
      action: 'Send a heart',
      technical: 'If {name} returns your interest, the chat will open automatically.',
    },
    pending_heart: {
      title_female_1: 'We know you like {name}',
      description_female_1: 'Before you can chat, {name} needs to return your gesture.',
      title_female_2: '{name} now knows you would like to meet her',
      description_female_2: 'We sent her a notification. Only her response stands between you and a conversation.',
      title_female_3: 'You have already made the first move',
      description_female_3: '{name} received your sign. When she responds, your chat will be ready.',
      reminder_female: 'No worries - we will occasionally remind her about your profile.',
      title_male_1: 'We know you like {name}',
      description_male_1: 'Before you can chat, {name} needs to return your gesture.',
      title_male_2: '{name} now knows you would like to meet him',
      description_male_2: 'We sent him a notification. Only his response stands between you and a conversation.',
      title_male_3: 'You have already made the first move',
      description_male_3: '{name} received your sign. When he responds, your chat will be ready.',
      reminder_male: 'No worries - we will occasionally remind him about your profile.',
      action: 'Cancel sent heart',
    },
    paired_heart: {
      title_female_1: 'You both sent a heart!',
      status_female_1: 'You and {name} can chat now.',
      title_female_2: '{name} returned your gesture',
      status_female_2: 'This is a good moment to send the first message.',
      title_female_3: 'This could be the start of a good conversation',
      status_female_3: '{name} wants to get to know you too.',
      title_male_1: 'You both sent a heart!',
      status_male_1: 'You and {name} can chat now.',
      title_male_2: '{name} returned your gesture',
      status_male_2: 'This is a good moment to send the first message.',
      title_male_3: 'This could be the start of a good conversation',
      status_male_3: '{name} wants to get to know you too.',
      action: 'Open chat',
      technical: 'The chat is already open for both of you.',
      cancel: 'End pairing',
    },
    incoming_heart: {
      title_female_1: '{name} has already made the first move',
      status_female_1: 'She let you know that she would like to get to know you better.',
      title_female_2: '{name} liked your profile',
      status_female_2: 'Now the next move is yours.',
      title_female_3: '{name} is interested in your profile',
      status_female_3: 'She has just made the first move.',
      title_male_1: '{name} has already made the first move',
      status_male_1: 'He let you know that he would like to get to know you better.',
      title_male_2: '{name} liked your profile',
      status_male_2: 'Now the next move is yours.',
      title_male_3: '{name} is interested in your profile',
      status_male_3: 'He has just made the first move.',
      action_female: 'I want to meet her too',
      action_male: 'I want to meet him too',
      technical: 'The chat will open as soon as you respond.',
      processing_title: 'Connecting you...',
      processing_description: 'Opening your chat with {name}.',
      decline_title: 'Do you want to decline this heart?',
      decline_description: 'This person will disappear from your received hearts list.',
      decline_action: 'Yes, skip',
    },
    open_chat: 'Open chat',
    currently_looking_at_distance: 'Currently looking within distance',
    from_city: 'town',
    search_parameters: 'Search parameters',
    age_you_are_looking: 'Looking for people of age',
    change_age: 'Change age',
    add_images: 'Add a photo',
    add_images_description: 'Add your photo to help others find you and unlock partner suggestions.',
    go_to_image_adding: 'Go to adding photos',
    add_photo: {
      description: 'Every connection starts with a real person. Show who you are and unlock suggestions of people you could meet.',
      action: 'Add my photo',
      hint: 'It doesn’t have to be perfect. Just make it yours.',
      your_place: 'This is your place',
      hello: 'It all starts with hello',
    },
    discovery_empty: {
      initial: {
        title: 'Good connections',
        title_accent: 'have their own timing.',
        description: 'We don’t have anyone matching your preferences right now.',
      },
      exhausted: {
        title: 'That’s everyone for now.',
        title_accent: 'See you again soon!',
        description: 'Drop by again in a while. Your next visit could bring a new connection.',
      },
      waiting: {
        title: 'Give hearts',
        title_accent: 'a moment to find their way to you.',
        description: 'No one has sent you a heart yet. Check back later - that may be when someone makes the first move.',
      },
      sent: {
        title: 'A good conversation can start',
        title_accent: 'with one heart.',
        description: 'You have not sent a heart to anyone yet. Meet new people - one of them might be the start of something meaningful.',
      },
      return_message: 'Come back soon - someone might surprise you.',
      links_label: 'Explore in the meantime',
      discover_action: 'Meet new people',
      sent_hearts_action: 'Sent hearts',
      received_hearts_action: 'Received hearts',
      profile_action: 'Your profile',
      photos_action: 'Your photos',
      hearts_action: 'Hearts',
      pairs_action: 'Your matches',
    },
    want_to_see_more: 'Want to see more people?',
    go_change_your_preferences: 'Adjust your preferences to see more people suggestions.',
    change_preferences: 'Change parameters',
    card: {
      no_photo: 'No photo yet',
      liked_you: 'You got a heart',
      your_move: 'Your move!',
      like_back: 'Send a heart back and start chatting right away.',
      photos: 'Profile photos',
      photo: 'Photo {number}: {name}',
      show_photo: 'Show photo {number}',
      previous_photo: 'Previous photo',
      next_photo: 'Next photo',
    },
    he_sent_you_a_heart: 'He sent you a heart',
    she_sent_you_a_heart: 'She sent you a heart',
    height: 'Height',
    physique: 'Body structure',
    children: 'Children',
    eye_color: 'Eye color',
    marital_status: 'Marital status',
    work: 'Work',
    education: 'Education',
    confession: 'Confession',
    attitude_to_marriage: 'Attitude to marriage',
    report: 'Report',
    block: 'Block',
    report_user: 'Report user',
    reason: 'Reason',
    ugly_profile: 'Offensive profile - photos / description',
    report_other: 'Other',
    stealing_personal_data: 'Attempt to extort personal data',
    stealing: 'Attempted to steal / extort money',
    hate_talk: 'Propagating Hatred',
    fake: 'Spoofing (suspected fake account)',
    also_block_user: 'Block the user additionally',
    sure_to_black_and_unpair: 'Are you sure you want to block the user and break the couple?',
    sure_to_black: 'Are you sure you want to block the user?',
    block_user: 'User lock',
    yes_block: 'Yes, block',
    blocked: 'User has been blocked',
    thanks_for_report: 'Thank you for reporting',
    write_more: 'write more...',
    looking_for: 'I\'m looking for',
    looking_for_women: 'women',
    looking_for_men: 'men',
    aged: 'in&nbsp;age',
    click: 'Press',
    and_start_talking: 'and start chatting <br>chat!',
    visits: 'Visits',
    images: 'Photos',
    who_visited_you: 'Who visited you?',
    deleted: 'The selected user does not exist',
    one_time: 'time',
    times: 'times',
    no_new_visits: 'You have no new visits',
    users_not_found: 'User not found',
    pair: {
      are_you_sure_to_break: 'You want to break a couple',
      are_you_sure_to_break_confirm: 'Are you sure you want to do this?',
      yes_break: 'Yes, break it'
    },
    heart: {
      cancel_q: 'Do you want to cancel the heart?',
      cancel_confirm: 'The heart you sent earlier will be canceled.',
      yes_cancel: 'Yes, cancel the heart',
    }
  },
  current_user: {
    edit_profile: 'Edit Profile',
    edit_images: 'Edit Photos',
    basic_info: 'Basic information',
    edit_success: 'Editing profile successful!',
    more: {
      about_me: 'More about me'
    },
    preferences: {
      is: 'Preferences'
    },
    images: {
      is: 'Your photos',
      header: 'Present your <span>best</span>side!',
      from_computer: 'Click here or drag photos from computer',
      from_mobile: 'Click here to add photos',
      can_change_order: 'You can change the order of the photos.',
      uploaded_images: 'Uploaded photos',
      max_size_image: 'The {name} photo cannot be larger than 8MB',
      order_changed: 'Order editing successful!',
      confirm_delete: 'Delete photos',
      confirm_delete_text: 'Are you sure you want to do this? This operation cannot be undone? ',
    },
    lang: {
      choose: 'Language Selection'
    }
  },
  profile: {
    edit: 'Edit profile'
  },
  premium: {
    is: 'Premium',
    account: 'Premium account',
    buy: 'Your premium',
    see_with: 'View From',
    PREMIUM: 'PREMIUM',
    to: 'Your account is premium to',
    see_benefits: 'See premium benefits',
    hide: 'Hide',
    benefits: 'Benefits',
    free: 'Free',
    no_ads: 'No Ads',
    be_higher: 'Display above <span class="is-hidden-mobile">other users</span>',
    ukraine: `🇺🇦 100% of payments made by our users in the period 05/03/2022 will be donated until further notice <a
href="https://pomagam.pl/solidarnizukraina" target="_blank" rel="nofollow">🇺🇦 "Solidarni z Ukrainą"</a>
organized by the <a href="https://pomagam.pl/" target="_blank" rel="nofollow">pomagam.pl</a>foundation.
Documentation of this initiative will be available on our profile on <a
href="https://www.facebook.com/jatyportalrandkowy" target="_blank" rel="nofollow">facebook</a>. We encourage you to
like 🇺🇦`,
    see: 'View',
    more_with: 'More benefits from',
    expires: 'You are premium to'
  },
  like: {
    hearts: 'Hearts',
    sent: 'Sent',
    received: 'Received',
    you_didnt_sent_to_anyone: 'You haven\'t sent a heart to anyone yet',
    go_to_propositions_to_like: 'Go to the suggestions and connect with people who match your preferences.',
    sent_hero_title: 'Hearts',
    sent_hero_description: 'The people you liked will see your heart. When they return the interest, the chat will open.',
    sent_hero_story: 'Waiting for a heart in return',
    received_hero_title: 'Hearts',
    received_hero_story: 'Return it and start chatting',
    linking_description: 'Someone sent you a heart? Return it to create a match and start chatting right away.',
    nobody_sent_you: 'Nobody has sent you a heart yet'
  },
  pair: {
    yours: 'Your matches',
    page_description: 'Here you see people you like and they are liking you',
    no: 'You don\'t have any couple yet'
  },
  delete_request: {
    title: 'Delete account',
    stay_eyebrow: 'Before you go',
    stay_title: 'Every conversation on JaTy can be the start of something meaningful',
    stay_text: 'We are building JaTy together with the people who use it. Give yourself - and us - one more chance: a new profile, one heart, or a simple hello can sometimes lead further than expected.',
    stay_action: 'Meet more people',
    description: `
    <p class="mb-2">Deleting your account permanently removes:</p>
    <ul class="mb-2 dotted">
      <li>your data,</li>
      <li>your photos,</li>
      <li>your message history,</li>
      <li>your subscription.</li>
    </ul>
    <p class="mb-2">We do not send emails about this process, so:</p>
    <ul class="dotted mb-2">
      <li><b>No,</b> you will not receive a notification when your account is deleted.</li>
      <li><b>No,</b> you will not receive a notification when the request is sent.</li>
      <li><b>No,</b> you will not receive notifications about additional questions.</li>
    </ul>
    <p class="has-text-danger delete-text mb-2">This process cannot be undone.</p>
    <p class="mb-2">You can register again, but your current account will no longer be available.</p>
    <p class="mb-0">If you still want to delete your account, tell us what we could improve and submit your deletion request.</p>`,
    reason: 'What did you dislike most about our portal? (mandatory)',
    ask: 'Ask to delete account',
    cant_cancel: `
      <div class="content">
        <p class="has-text-centered has-text-primary is-size-3 mb-2">♡</p>
        <p class="has-text-weight-semibold has-text-centered">Remember that this process cannot be undone.</p>
        <div class="notification is-info has-text-white">
          JaTy is free, so you do not lose anything by staying a little longer. Give yourself a chance to meet someone valuable, start a conversation or find love when you least expect it.
        </div>
      </div>
      `,
    yes_delete: 'Yes, ask for account deletion',
    no: 'I will stay and try again',
    last_step: 'Last step',
    press_yes_to_delete: 'Press "Yes" if you want to permanently delete your data',
    permanently: 'Yes, permanently delete account'
  },
  email_confirmation: {
    resend: 'Send again.',
    didnt_received: 'Email not received?',
    go_to_email: 'Go to your e-mail to confirm it',
    mail_sent: 'Mail has been sent',
    already_send_in_10_minutes: 'You asked to resend your email in the last 10 minutes',
    on_mail: 'to mailbox',
    you_she_received: 'got',
    you_he_received: 'got',
    email_sent_from_us: 'an email from us with instructions on how to confirm your account.',
    do_now: 'Confirm your email address!',
    great_last_step: 'Great! The last step!'
  },
  payment: {
    you_save: 'Save',
    mon: 'month',
    choose_one: 'Choose one of the options',
    go_to_p24: 'Go to Przelewy24',
    thanks_title: 'Thank you for paying for the order!',
    thanks_text: 'We will inform you as soon as we get information about your payment.',
    choosen: 'Selected',
    digital: {
      active: 'You don\'t need to do anything else. Your subscription is active.',
      deactived_globally: 'In-app payments disabled.',
      manage: 'Manage subscription',
      active_now: 'Activate now',
      seven_days_free: '7 days free',
      with_subscription: 'subscription',
    },
  },
  alert: {
    is: 'Notifications',
    description: 'You can see a list of notifications that allow you to control what\'s new in your account.',
    read_all: 'Mark all read',
    no_new: 'You have no new notifications',
    nothing: 'Nothing interesting is happening',
    see_all: 'See all notifications',
    one_more_step: 'One more step',
    new: 'New',
    add_more_info_about_you: 'Complete information about yourself',
    you_are_premium: 'You are premium',
    your_account_is_premium: 'Your account has been extended',
    you_are_pair: 'You are a couple',
    description_warning: 'Your profile description was removed',
    photos_warning: 'Your profile photos were removed',
    you_received_warning_for_description: 'You received a warning because your profile description did not meet our rules',
    you_received_warning_for_photos: 'You received a warning because your profile photos did not meet our rules'
  },
  profile_description_rules: {
    title: 'Public profile description rules',
    text: 'Do not add contact details or links to messengers and social media. Do not add advertising or direct sexual propositions. Breaking these rules may result in your description being removed and a warning.',
    link: 'Read the full description rules'
  },
  premium_box: {
    twa: `
     <span class="has-text-primary">Premium</span>for 7 days for FREE! Then&nbsp;<span
              class="has-text-danger">50&#37;</span>&nbsp; discounts.`,
    left: 'Left',
    countdown_text: `<span class="has-text-primary">Premium</span> for <span class="countdown-price">29.99 & nbsp; PLN</span>
             <span class="countdown-promo-price has-text-danger">69.99 & nbsp; PLN</span>
              for 12 months!<br>`,
    text: `JaTy becomes <span class="has-text-primary">free</span>for everyone! From March 5th
           2022 premium has only two benefits: "no ads" and "being slightly higher in the results
           search". The rest of the functionality becomes free!<br><br>🇺🇦 100% of payments made by ours
           users in the period 05.03.2022 until further notice, we will donate to a fundraiser
          <a href="https://pomagam.pl/solidarnizukraina" target="_blank" rel="nofollow">🇺🇦"Solidarity with Ukraine"</a>
           organized by the<a href="https://pomagam.pl/" target="_blank" rel="nofollow">Pomagam.pl</a>foundation.
           Documentation of this initiative will be available on our profile on <a
           href="https://www.facebook.com/jatyportalrandkowy" target="_blank" rel="nofollow">facebook</a>.
           We encourage you to like 🇺🇦`
  },
  city_chooser: {
    loading: 'Loading',
    no_results: 'No results'
  },
  home: {
    chat_image_alt: 'A chat conversation on the JaTy dating site',
    app_image_alt: 'The JaTy dating site on a phone and computer',
    moderation: `
          <p class="mb-3">
            The JaTy team responds to abuse and bans accounts that break our rules.
            Artificial intelligence (AI) supports this work by helping review profiles, moderate content and detect suspicious behaviour.
            This helps us tackle fake accounts, spam and attempted scams more efficiently.
          </p>
          <p class="mb-3">
            AI helps us look after the space where people meet. You decide who to talk to, who to send a heart to
            and whether to meet in person. We want you to spend more time getting to know people
            and less time dealing with unwanted attention.
          </p>
          <p>
            No moderation system catches every problem, and mistakes can happen.
            If something concerns you, use the report option on the user’s profile.
            For problems with your account or the site, you can also <a href="{contact_url}">contact the JaTy team</a>.
            Your reports help us look after the community.
          </p>`,
    h1: 'Free Dating Site',
    go_for_jaty: 'Go to JaTy',
    login: 'Log in',
    register: 'Sign up',
    thousands_of_users: 'Thousands of users',
    every_day_new_users: 'New users every day!',
    totally_free: 'Completely free',
    all_features_free: 'All features are available for free!',
    only_real_accounts: 'Active moderation',
    accounts_constantly_verified: 'Our team, supported by AI',
    safe_guarantee_title: 'Your safety matters',
    ssl: 'SSL certificate',
    spam_filter: 'Spam filter',
    fake_control: 'Fake profile detection',
    hero_intro: 'Meet someone you want to keep talking to. Love, friendship, or a first coffee together?',
    hero_note: 'Free to use. At your pace. Adults 18+.',
    about_label: 'About us',
    about_heading: 'Get to know JaTy',
    about_intro: 'It began as an idea for a dating site for friends. Today we are building an independent, free place to meet people. Find out who is behind JaTy and what matters to us.',
    about_link: 'More about JaTy',
    how_it_works: 'How it works',
    discover: 'See how it works',
    chat_graphic_section_h1: 'Meet singles and make meaningful connections',
    chat_intro: 'A few simple steps to a new connection. You decide what comes next.',
    steps: [
      {
        title: 'Be yourself',
        text: 'Add a photo and a few words about yourself. Choose who you would like to meet.'
      },
      {
        title: 'Send a heart',
        text: 'Browse profiles. When you like each other, you become a match.'
      },
      {
        title: 'Start talking',
        text: 'Send that first message. Meet in person when you both feel ready.'
      }
    ],
    free_heading: 'JaTy is a <strong class="has-text-primary">free</strong> dating site',
    free_intro: 'Chat, hearts and matching are free. No subscriptions or payments to unlock a conversation.',
    free_label: 'for all features',
    free_features: [
      'Chat',
      'Hearts',
      'Matching',
      'Search'
    ],
    safety_intro: 'Our team reviews content and responds to abuse with AI support. You choose who you want to talk to.',
    moderation_heading: 'How do AI and our team help make online dating safer?',
    online_to_live_heading: 'Online dating can become a real-life date',
    online_to_live: `
          <p class="mb-3">
            JaTy is an online dating site that helps you build long-term relationships, but it can also help you meet new friends for a walk, a drink, coffee or a movie.
            The internet makes the first step easier, especially when everyday life gives you little time or few chances to meet someone new.
          </p>
          <p class="mb-3">
            A good conversation often shows whether you share a similar sense of humor, values, plans and lifestyle.
            That is why online dating can become something very real: a first meeting, a weekend together, a serious relationship or a friendship that lasts.
          </p>
          <p>
            JaTy works in your browser, so you can use it on a phone, tablet or computer without installing a mobile app.
            Your profile and conversations are available wherever you have internet access, at home, while travelling or whenever you have a quiet moment during the day.
          </p>`,
    app_label: 'Always within reach',
    faq_title: 'JaTy Free Online Dating - Frequently Asked Questions (FAQ)',
    faq_intro: 'A few answers before your first “hello”.',
    faq_items: [
      {
        question: 'Is JaTy really a free dating site?',
        answer: `<p>
              Yes. Messages, hearts, matching, profile browsing and search are available for free.
              JaTy does not require a paid subscription, premium package or one-time payment to unlock contact.
            </p>
<p class="mt-1">The features needed for online dating are available without payment.</p>`
      },
      {
        question: 'Why is JaTy free?',
        answer: `<p>
              We want to give users a real chance to find love, friendship or a meaningful connection without charging for the basic ability to talk.
              That is why we focus on simple dating tools, safety, reducing vulgar content and checking suspicious or fake accounts.
            </p>`
      },
      {
        question: 'Who can I meet on JaTy?',
        answer: `<p>
              JaTy brings together people from Poland and other places who are looking for love, friendship, conversation or a serious relationship.
              We care about limiting fake profiles and dishonest behaviour. No dating site can promise that every profile will be perfect, but we keep working to make the JaTy community as authentic and safe as possible.
            </p>`
      },
      {
        question: 'Is registration difficult?',
        answer: `<p>
              No. <a href="{register_url}">Registration</a> on JaTy is simple and takes only a moment.
              After creating an account, you can complete your profile, add a photo, set your preferences and start meeting people who are also interested in online dating.
            </p>`
      },
      {
        question: 'Can I use JaTy without a mobile app?',
        answer: `<p>
              Yes. JaTy currently works as a dating site in your browser. You can use it on a phone, tablet or computer without installing a mobile application.
              This is convenient if you want access to your profile and messages from different devices.
            </p>`
      },
      {
        question: 'How do dating sites work?',
        answer: `<p>
              Different dating sites use different features, but the goal is usually the same: helping people meet someone with whom they can build a relationship, friendship or love.
              On JaTy you can browse profiles, send hearts, use matching and write messages when someone interests you.
            </p>`
      },
      {
        question: 'Who is JaTy for?',
        answer: `<p>
              JaTy is for adult singles, lonely people, shy people, busy people and anyone who wants to meet others online in a calm and natural way.
              You can look for a serious relationship, friendship, conversation or someone to meet for a walk, coffee, a drink or a movie.
            </p>`
      },
      {
        question: 'Is JaTy only for adults?',
        answer: `<p>
              Yes. JaTy is available only to adults. It is not a place for scams, earning money from other users or publishing vulgar content.
              Our goal is to help people meet real users and build normal, honest relationships.
            </p>`
      },
      {
        question: 'How do we protect your data?',
        answer: `<p>
              People who are not registered on the portal cannot see you or your profile data.
              We do not share user data with third parties for purposes that conflict with the operation of the service.
              JaTy uses security standards designed to help users stay private outside the portal and decide for themselves who should learn more about them.
            </p>`
      }
    ],
    closing_intro: 'Create a free account. Let someone get to know you.',
    footer_note: 'A place for new connections.',
    chat_graphic_section: `
          <p class="mb-3">
            JaTy is a free dating site created for people who want to meet someone real online.
            Whether you are looking for love, friendship, a serious relationship or simply a good conversation, online dating can make the first step easier.
            You do not need to install an app or pay before you can start discovering profiles and talking to other people.
          </p>
          <p class="mb-3">
            On JaTy you can meet singles from Poland and beyond, browse profiles, send hearts, use matching features and start conversations when someone catches your attention.
            For shy people, busy people and anyone who finds it difficult to meet someone new in everyday life, a dating website can be a natural way to begin.
          </p>
          <p class="mb-3">
            The goal is simple: help adults find meaningful connections in a place that feels clear, accessible and safe.
            Some users are looking for a long-term partner, others want to make friends, go for a walk, have coffee, go to the cinema or slowly build trust through messages.
          </p>
          <p>
            JaTy gives you the basic tools you need for free online dating: profiles, chat, hearts, matching and search.
            Create an account, write a few honest words about yourself and start meeting people at your own pace.
          </p>`,
    free_heading_text: `
          <p class="mb-3">
            JaTy works as a free dating site: messages, hearts, matching, profile browsing and search are available without payment.
            We believe that the most important online dating features should be open to users who are looking for love, friendship or a meaningful relationship.
          </p>
          <p class="mb-3">
            Free online dating should not mean creating an account only to discover that every real conversation is locked behind a subscription.
            With JaTy you can start writing, react to profiles, check matches and meet new people without subscriptions, premium packages or paid unlocks.
          </p>
          <p>
            The core idea stays the same: a dating portal should help people meet online, not block the first message behind a paywall.
          </p>`,
    we_will_help_you_for_free_heading: 'JaTy helps you look for love for free!',
    we_will_help_you_for_free: `
          <p class="mb-3">
            Would you like to meet someone you connect with? Do you feel lonely? Are you single and ready to try online dating without pressure or hidden costs?
            If so, the free dating site JaTy is a good place to begin.
          </p>
          <p class="mb-3">
            Sign up, complete your profile and write a few natural sentences about who you are and who you would like to meet.
            The more honest your profile is, the easier it becomes to start a conversation with someone who is looking for the same thing: love, friendship, a serious relationship or a new connection.
          </p>
          <p class="mb-3">
            We do not promise magic or a ready-made formula for love. What we do offer are simple tools that make the first contact easier: profiles, search, hearts, matching and messages.
            Sometimes one conversation is enough to make the day feel lighter and to start a connection that grows in a good direction.
          </p>
          <p>
            JaTy is for people who want to meet others without pretending to be someone else.
            You can take your time, decide who you want to reply to and move from online dating to a real-life meeting only when you feel ready.
          </p>`,
    app_heading: 'Free online dating in your browser',
    app: `
          <p class="mb-3">
            The JaTy dating site works conveniently in the browser on your phone and computer.
            You can log in with the same account, browse profiles, send hearts, use matching and write messages without installing an additional app.
          </p>
          <p class="mb-3">
            Browser-based dating is simple: it does not take storage space on your phone, does not require app updates and lets you use the service on different devices.
            Open JaTy, log in and return to your conversations whenever you have time.
          </p>
          <p>
            We want the portal to be clear, fast and comfortable both on a smartphone and on a larger screen.
            That way you can meet new people in a way that fits your day: in the morning, after work or in the evening when you finally have a moment for yourself.
          </p>`,
    read_more: 'Read more',
    read_less: 'Show less'
  },
  meta: {
    home: 'Meet singles on JaTy, a free dating site with chat, hearts and matching. Find new connections in a community moderated by our team with AI support.',
    login: 'Log in to JaTy to return to your conversations, check your hearts and meet new people on our free dating site.',
    contact: 'Contact the JaTy team for help with your account, to report a problem or to ask a question about using the dating site.',
    logout: 'Log out - JaTy is a free online dating site for singles, lonely people and everyone who wants to meet valuable people online.',
    register: 'Create a free JaTy account. Add a photo, complete your profile and meet singles. Chat, send hearts and find matches without subscriptions or fees.',
    redirect: 'Find love online - JaTy is a free dating site for singles looking for conversation, friendship, a serious relationship and real connections.',
    fast_login: 'Quick login - Return to JaTy and continue free online dating, conversations, matching and meeting new people in a safe dating portal.',
    login_layout: 'JaTy is a free online dating site where you can meet valuable people, start conversations and look for love for free.',
    regulamin: 'Read the JaTy terms and conditions, including registration requirements, user rights and responsibilities, and rules for using your account.',
    polityka_prywatnosci: 'Learn how JaTy processes personal data, what rights you have and how to contact us about your information.',
    cookies: 'Learn how JaTy uses cookies and how to manage them in your browser settings.'
  },
  title: {
    home: 'JaTy - free dating site and online chat',
    login_layout: 'JaTy - free online dating',
    help: 'Help Center - JaTy Online Dating',
    welcome: {
      index: 'Hello - JaTy Online Dating',
      about: 'Hello - JaTy Online Dating',
      images: 'Photos - JaTy Online Dating'
    },
    users: {
      index: 'Suggestions - JaTy Online Dating',
      liked: 'Hearts - JaTy Online Dating',
      liking: 'Hearts - JaTy Online Dating',
      _slug: '- JaTy Online Dating'
    },
    'current-user': {
      'verify-email': 'Validate your email',
      payments: {
        digital: 'Premium - JaTy Online Dating',
        index: 'Premium - JaTy Online Dating',
        thanks: 'Thank you - JaTy Online Dating'
      },
      edit: {
        'delete-request': 'Account deletion - JaTy Online Dating',
        images: 'Photos - JaTy Online dating',
        index: 'Basic information - JaTy Online Dating',
        lang: 'Language selection - JaTy Online Dating',
        'notification-preferences': 'Notification preferences - JaTy Online Dating',
        password: 'Change password - JaTy Online Dating',
        preferences: 'Preferences - JaTy Online Dating',
        profile: 'More about me - JaTy Online Dating'
      }
    }
  },

  terms_of_use: `<h2> General Terms of Service Provision (hereinafter referred to as" General Terms ") </h2>
    <p><a href="#moderacja">Profile, message, warning and ban rules – AI moderation and appeals (section 6a)</a></p>
    <p>These General Terms and Conditions govern the use of the Jaty website (the “Jaty Service”). The operator of the service and the party to the contract with the Customer is WHIPO sp. z o.o., a Polish limited liability company with its registered office at ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Poland, tax identification number (NIP): 5342666118, hereinafter referred to as “Jaty”. Contact: <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>.</p>
    <p> Upon registration on the Website, the Customer declares and warrants that he has read and accepted the General Terms and Conditions. The general terms and conditions therefore form an integral part of the contract. </p>
    <p> The general conditions apply to all customers. </p>
    <p> People over 18 years of age may use the Jaty Service. </p>
    <h3> 1. Subject of the contract </h3>
    <p>(1) The contract covers services provided free of charge. Registration and all website features, including browsing profiles, searching, sending hearts, matching and messaging, are free. Jaty offers the following services (see also section 3, “Jaty service and scope of services”):</p>
    <p> Customer introduction to the Service database and data management; </p>
    <p> Enabling contact with other Customers of the Jaty Service. </p>
    <p> (2) The subject of the contract between the Customer and the Jaty Service Center is neither marriage matching, matrimonial mediation, nor activity aimed at establishing a partnership or marriage. </p>
    <p>(3) Jaty is for meeting people privately. Advertising campaigns, spam and using the service for fraud are prohibited. Section 6a sets out the detailed rules and the exception for private messages between adults.</p>
    <p> (4) To use the Jaty Website, it is necessary to have devices that allow the use of the Internet, an e-mail mailbox and a web resource browser that allows displaying WWW pages. </p>
    <h3> 2. Using the Service and concluding a contract </h3>
    <p> (1) The use of the Jaty Service requires registration. During registration, the Customer chooses a username under which other customers of the Service will be visible, and a personal password. Alternatively, the Jaty Service may assign to the Customer the so-called "Code". The e-mail address provided is used only for contacting the Service of Jaty with the Client and is not passed on to other Clients of the Service of Jaty. </p>
    <p> (2) By registering, the Customer accepts these General Terms and Conditions and declares that he or she is of legal age, i.e. at least 18 years of age. </p>
    <p> (3) The contract between the Customer and the Jaty Service Center is concluded upon the Customer's registration. These General Terms and Conditions apply to this agreement. Registration is free. </p>
    <p>(4) Jaty does not currently offer paid accounts, paid packages or subscriptions. Access to website features does not require accepting any obligation to pay.</p>
    <p>(5) The Customer declares that the information provided during registration is accurate.</p>
    <p>(6) Jaty may block access to the service if the Customer violates the law, the rights of third parties or the obligations set out in section 6, “Customer Responsibilities”. In the event of a serious breach of these General Terms and Conditions or the contract, Jaty may pursue remedies available under applicable law.</p>
    <h3> 3. Jaty service and scope of services </h3>
    <p> (1) The provision of services by the Jaty Website begins with the registration and filling in the profile data. Filling out consists of a series of questions to which the Client answers. </p>
    <p> (2) The Customer's responses and further personal data are entered into the database of the Jaty Website and compared there with the data of other Customers of the Jaty Website. The comparison is made on the basis of a mathematical algorithm (computational operation) that allows to determine the compliance of two customer profiles. </p>
    <p> (3) As a result of comparing the Customer's data with the data of other Customers of the Jaty Website, the Customer receives a list of those Customers who best suit him, in the form of anonymous short profiles. </p>
    <p> (4) The Client may then contact other Jaty Service Clients proposed to him. Direct contact between Jaty's Service Clients is possible only with mutual consent of the Clients. Such mutual consent may be obtained in such a way that a given Customer sends his anonymous abridged profile to the selected Customers (so-called "contact"). The other Customer may then decide whether he wants to respond or not. Contacting within the meaning of the General Conditions also when the Customer agrees to contact proposals from another Customer.Communication between Customers takes place via the internal communication system of the Jaty Website. </p>
    <p>(5) Making contact and sending messages are free of charge.</p>
    <p> (6) A month should be understood not as a calendar month but a period of full 31 days. </p>
    <p>(7) Jaty does not currently charge for access to website features. If the scope of services changes in the future, the Customer will be informed in accordance with applicable law and these General Terms and Conditions.</p>
    <p> (8) Jaty Website does not guarantee that the data provided by the Customers is true. </p>
    <p> Jaty Website does not guarantee that the contact will be made effective during the term of the contract. </p>
    <p> (9) Basically, the service provided by Jaty is available 24/7. Availability is estimated at 95% on an annual basis. The above value does not include interruptions related to the maintenance or update of the software or caused by factors that are not dependent on Jaty, such as unavailability of Internet services due to the fault of third parties or due to force majeure. Jaty recommends its clients to use the latest (browser) technology and to use appropriate browser settings (Java script, cookies and pop-ups activation) for better use of Jaty. Where outdated or non-standard technology is used, Jaty cannot guarantee the proper operation of all services and features. </p>
    <p> (10) The customer acknowledges and agrees that all content submitted by him to the Jaty website is available for viewing by all customers on his list of featured contacts. This applies regardless of whether other customers have registered with the site operated by Jaty or through other websites / applications or partners cooperating with Jaty. In this way, customers can benefit from a central database maintained by Jaty over services that are available through various domains and websites / applications, seeing these users in their recommended contacts. </p>
    <h3> 4. Mutual notifications made by the Customer and Jaty Service </h3>
    <p> (1) Messages from Jaty to the client are sent through the screens displayed after "Logging in", i.e. when the client has entered his username (or assigned Code) and password, or to the e-mail address provided by the client during registration or currently stored by the customer in their profile. </p>
    <p> (2) Messages from the Customer to the Jaty Service Center are sent by e-mail to the e-mail address provided on the Jaty website (e.g. jaty@jaty.pl), by letter or fax. When contacting Jaty by letter or fax, for unique authorization and protection against misuse, it is absolutely imperative that the Customer provide at least their registered e-mail address on the Jaty website, the country in which they use Jaty's services and the username (or mu code) in correspondence with Jaty. When contacting Jaty by e-mail, for authorization and protection against abuse, it is absolutely imperative that all e-mails sent by the Client to Jaty are sent from the e-mail address provided by the Client during registration or currently stored by The client in his profile. </p>
    <h3> 5. Liability of the Jaty Website </h3>
    <p> (1) The Jaty website is not responsible in any way, within the limits consistent with applicable law, for the materials and data provided and published on the Jaty website by customers and for their truthfulness, reliability and authenticity. The Jaty website is not responsible for the correctness of the data provided by the Jaty website customers in the personality test. The Jaty website is therefore not responsible for the correctness of the test result and the comparison of customer profiles, because the preparation of the test result and comparison of customer profiles are based on the data provided. If we learn that the client is in breach of legal regulations; violates one or more of the rights of a third party or breaches the customer's existing obligations under clause 6, then clause 2.6 will apply. </p>
    <p> (2) Direct contact between Jaty's Service Clients takes place only with mutual consent (see section 3 "Jaty's Service and the scope of services"). Jaty's Service is therefore not liable if no contact is made during the term of the agreement. Jaty Service makes every effort to mediate in contacts between Jaty Service Customers by ensuring appropriate technical conditions. </p>
    <p> (3) Jaty's website is not responsible for the misuse of data and information by others, because despite the express prohibition (see point 6 "Customer's obligations"), customers may use the Jaty's website in violation of the law. when the information that the Customer himself has made available to a third party is used unlawfully by a third party. </p>
    <p> (4) Jaty does not guarantee that the service will be error-free at all times, ie that it will be constantly available without interruption. In particular, Jaty is not responsible for failures of technical equipment or the quality of access to services due to force majeure or events beyond Jaty's control (e.g. failure of communication networks). </p>
    <p> (5) Jaty is not responsible for the unlawful acquisition of customer personal data by third parties, e.g. in the form of access to the database by hackers. </p>
    <p> (6) For losses other than those resulting from the above-mentioned reasons, Jaty will be liable only in cases of intentional or gross negligence on the part of its management, employees or contractors, and such liability is proportional to the other reasons that contributed to the loss. </p>
    <p> (7) Jaty is only liable for slight negligence in the event of damage to life, body or health or in the event that it has breached essential contractual obligations. Liability in the latter case is limited to the foreseeable, direct losses typical of this type of contractual relationship. </p>
    <p> (8) Contractual liability is otherwise excluded. </p>
    <h3> 6. Customer Responsibilities </h3>
    <p> (1) The customer is solely responsible for all data provided by him. She/he ensures that the data provided by him is correct. The customer undertakes not to provide the data of third parties as his own. Providing false data violates the provisions of the contract and the General Terms and Conditions and may require the Jaty Website to take appropriate legal steps. </p>
    <p> The customer undertakes to keep the data provided on the Jaty Website, in particular contact details, up-to-date. </p>
    <p> The Jaty website is entitled to check the content of the profile, including the posted photos, in terms of their compliance with the law, General Conditions and the contract. Jaty's website is entitled to reject, change and even delete the content of the data. </p>
    <p>(2) Public profile descriptions must not contain contact details for communicating outside Jaty. Section 6a explains this rule and the rules for exchanging contact details privately.</p>
    <p> (3) The Customer is obliged to treat confidential data (in particular names, home addresses, e-mail addresses, website addresses, telephone numbers and faxes) regarding e-mail, messages and notifications received from other Customers of the Jaty Website and to not to disclose this data to third parties without the consent of the data subject. It is forbidden to disclose the data of persons who are not Clients of the Jaty Website. </p>
    <p>(4) The Customer must not use Jaty for advertising, commercial spam or recruitment to other services. Section 6a.3 defines the exception for direct private proposals between adults and its limits.</p>
    <p> (5) The Client undertakes not to use the Jaty Service for the purpose of: </p>
    <p>sending unlawful or defamatory material or content that violates section 6a;</p>
    <p> threats, harassment, defamation etc; </p>
    <p>obtaining money, data or access to accounts through deception, coercion or blackmail;</p>
    <p> violate the rights of third parties. </p>
    <p> The customer also undertakes to: </p>
    <p> not to introduce data containing viruses (infected software) to the Website; </p>
    <p> not to enter data containing software or other materials protected by copyright or industrial property rights to the Jaty Website, unless the Customer is the owner of a given right or has the necessary consent of the holder of the right to use the software or materials; </p>
    <p> not to use the Jaty Website in a way that may adversely affect the availability of the Jaty Website offer to other Customers; </p>
    <p> not to interfere with the computer system of other Clients, in particular not to take illegal actions related to the e-mail of other Clients. </p>
    <p>(6) The response to a violation is determined under section 6a: removal of a description or photos and a warning, a ban, or referral for human review. These rules do not exclude remedies available under applicable law.</p>
    <p>(7) If the Customer uses data from the Jaty Service for commercial purposes, Jaty may pursue remedies available under applicable law.</p>
    <p> (8) The customer undertakes to release the Jaty Website from any effects of lawsuits, claims for damages, losses and receivables that arise in connection with his registration on the Jaty Website and use of it. The customer indemnifies the Jaty Service from all civil liability and from all liabilities and damages that may arise as a result of claims arising from slander or insult, and from violating the rights of other customers. </p>
    <p> (9) The client should receive incoming messages and reply to them regularly and, if necessary, archive them on his own computer or other data carrier. </p>
    <p> Jaty's website is entitled, without the consent and notification of the Client, to delete messages saved in the Client's account after twelve (12) months from sending or receiving the message by the Client. </p>
    <p> The Jaty Service Center is entitled, without the consent and notification of the Customer, to delete the account of the Customer who does not use the free Jaty Service for a period of at least six (6) months. First of all, this action serves to protect the Customer's data, because the Jaty Service assumes that after this deadline, the Customer is no longer interested in storing his data, and secondly, this action is to clean the Jaty Service's database of inactive customers, which is tantamount to improving the quality of the service offered. . </p>
    <section id="moderacja" class="content">
    <h3>6a. Profiles, messages and moderation rules</h3>
    <p>Jaty is for adults aged 18 and over. These rules explain what content is allowed, when we remove a description or photos, and when we block an account (impose a ban). Public profiles and private conversations between adults have different rules. These specific rules take precedence over the general content and advertising provisions in sections 1 and 6.</p>
    <h4 id="moderacja-opisy">6a.1. Public profile descriptions</h4>
    <p>Your description should present you truthfully and help you meet people. Do not impersonate other people or Jaty staff. Stating your occupation, workplace, hobbies, orientation or preferences is not itself a violation.</p>
    <p><strong>Removal of the entire description and a warning</strong> apply to contact details for communicating outside Jaty: phone numbers, email addresses, and handles or links to messaging services or social profiles. This includes contact details disguised using spaces, emoji, words or other deliberate alterations. The rule also applies to genuine accounts and does not require suspected fraud.</p>
    <p>The same response applies to a direct but non-graphic sexual statement or proposal in a description, such as “I love sex” or “I am looking for sex”. Ordinary flirting, looking for a relationship, intimacy or an adventure, an allusion or simply stating a preference are not enough for a warning. A refusal such as “I am not looking for sex” is not a violation either.</p>
    <p><strong>A ban without a prior warning</strong> may apply to graphic, obscene descriptions of sexual acts or genitalia, sexual violence or detailed, vulgar sexual proposals; advertising paid sexual encounters, webcam services or the sale of erotic content; product or service advertising, commercial spam and recruitment to other services. Public descriptions are not a place for these offers.</p>
    <p>Confirmed fraud, phishing, fake verification, financial scams and fraudulent investments, genuine threats, incitement to violence or direct harassment are also grounds for a ban. Do not put links with a concealed or indeterminable purpose in your description; uncertainty about a link requires review, and an unfamiliar address alone does not prove fraud. Information indicating that the account holder is under 18 may lead to a ban after its meaning and context have been assessed.</p>
    <h4 id="moderacja-zdjecia">6a.2. Profile photos</h4>
    <p>Profile photos must not show visible genitalia or exposed female breasts with visible nipples or areolae. This also applies to drawings and computer-generated images. Content depicting sexual exploitation, sexual violence or the sexualisation of minors is prohibited.</p>
    <p>Photos considered inappropriate may be removed following assessment by a moderator.</p>
    <p>Cleavage, covered breasts, swimwear, tight clothing, a kiss or a suggestive pose do not by themselves violate these rules. We do not infer nudity beneath clothing, age or gender identity from appearance. An ordinary photo of a child is not itself sexual content; the account holder must still be an adult.</p>
    <p>A confirmed violation in at least one current photo results in <strong>removal of all photos from the profile and one warning</strong> if the account has no previous warning. If the user was previously warned about a description or photos and a violation is confirmed in the current gallery, we apply a <strong>ban</strong>. Warnings for descriptions and photos share one history. A previous warning alone, without a current violation, is not enough for a ban.</p>
    <p>Several violating photos assessed in one review do not lead to successive warnings and a ban during that review. A warning just issued is not treated as a prior warning for the remaining photos in that set. Serious suspicions of sexual exploitation or violence are also referred for urgent human review; we do not conclude that a crime occurred based on guesswork.</p>
    <h4 id="moderacja-wiadomosci">6a.3. Private messages</h4>
    <p>Exchanging contact details, suggesting a move to a messenger, flirting and sexual conversations are allowed in private conversations between adults. The restrictions on contact details and direct sexual statements in public descriptions do not carry over to private conversations. This concerns voluntary communication, not harassment, coercion or exploitation.</p>
    <p>We apply a <strong>ban without a prior warning</strong> where there is concrete evidence of spam, advertising or recruitment to external commercial services, fraud, phishing, financial scams or financial blackmail. Examples include a fake verification fee or fee to unlock contact, requests for BLIK authorisation codes, login credentials or card details under false pretences, fraudulent investments and building a fake romantic relationship to obtain money. Clear advertising does not require multiple recipients, and documented spam does not require a victim to have already lost money.</p>
    <p>We assess the content and purpose of messages and repeated scenarios, such as systematically collecting contact details under the same pretext. Having many conversation partners, similar greetings, intense flirting or a single suggestion to switch to email are not independent grounds for a ban. There is no automatic rule that a particular number of messages or recipients means a ban. Asking for help, describing financial hardship or discussing investments alone does not prove fraud – evidence of deception is required.</p>
    <p>Exception for private messages: a direct offer of your own in-person sexual services for money between adults is not, by itself, grounds for a warning, a ban or referral for review. This does not apply to public descriptions, advertising external websites or webcam services, or selling erotic photos and videos. The exception does not cover separately established spam, fraud, coercion, exploitation or other unlawful content.</p>
    <p>Serious suspicions of threats, blackmail or coercion outside a financial context are referred for human review. Emotional language or relationship conflict alone does not automatically establish a violation. Users are assessed for their own sent messages, not messages received from others. The absence of a visible reply does not prove a lack of consent or allow us to reconstruct the entire conversation.</p>
    <h4 id="moderacja-autentycznosc">6a.4. Impersonation, multiple accounts and bots</h4>
    <p>Impersonation for fraudulent purposes and using multiple accounts to evade bans, send spam, commit fraud or mislead users are prohibited. A confirmed violation may result in a ban. Similar descriptions, a shared photo, an unusual email address or a similar writing style alone are not enough to ban an account or a group of accounts. We consider additional links and the specific behaviour of each account.</p>
    <p>Bot accounts engaged in spam or fraud may be banned where template content is supported by other concrete evidence. The number of likes, a romantic writing style or the absence of proof of authenticity does not itself prove a violation.</p>
    <h4 id="moderacja-ai">6a.5. How we use AI</h4>
    <p>Jaty administrators use artificial intelligence tools provided by OpenAI to moderate descriptions, photos and sent messages, including retained message history. Analysis covers content and context, repeated patterns, account information and warning history. Its purpose is to detect violations and protect users from spam, fraud and prohibited content.</p>
    <p>AI can identify a concern and also initiate removal of a description or photos, a warning or a ban under these rules, without prior human approval of every individual action. A ban blocks use of the account. It does not mean that all of the user’s data has been deleted.</p>
    <p>Ambiguous cases are referred for human review. Being flagged for review is not a ban. We check that the assessed content is current before acting and do not penalise users for material already removed from their profile. An unreadable photo is a technical problem, not a violation. AI can make mistakes, so users can challenge a decision and obtain human review.</p>
    <h4 id="moderacja-kontekst">6a.6. Context and safeguards against mistakes</h4>
    <p>We assess specific content, authorship and context, not an isolated word. We do not treat a refusal, warning about scammers, account of experienced violence or quotation condemning a violation as a violation by its author. An obvious metaphor does not by itself constitute a genuine threat. Language, spelling mistakes, gender, orientation and origin are not evidence of fraud.</p>
    <p>Where several violations apply, we choose one main response. Confirmed grounds for a ban take precedence over a warning; we do not issue a warning solely to impose a ban immediately afterwards. A suspicion or earlier referral for review does not establish guilt.</p>
    <h4 id="moderacja-odwolanie">6a.7. Notifications, reports and appeals</h4>
    <p>We notify users of warnings or bans at the email address associated with their account. You can report a violation, ask for an explanation of a decision and appeal a warning, content removal or ban by emailing <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. Appeals are free and do not require logging in or access to the blocked account.</p>
    <p>Include your username or account email, identify the decision, explain why you disagree and provide any missing context. Do not send your password or login codes. Appeals are reviewed by a human – an authorised representative of WHIPO sp. z o.o., Jaty’s operator, or an authorised moderator – who can change the decision and lift an unjustified ban. We communicate the outcome and reasons by email. Rights under applicable law remain unaffected.</p>
    <p>Information about the data used in moderation is available in the <a href="/en/polityka-prywatnosci#moderacja-dane">privacy policy</a>.</p>
    </section>
    <h3> 7. Information on data protection, data processing and cookies </h3>
    <p> Our personal data protection can be found here: <a href="/en/polityka-prywatnosci"> https://jaty.pl/en/polityka-prywatnosci </a> </p>
    <h3>8. Termination of the contract and cessation of services</h3>
    <p>(1) Termination</p>
    <p>The contract for using the Jaty Service is free of charge and begins when the Customer registers.</p>
    <p>The Customer may terminate the contract at any time without giving a reason by using the contact form in the Help menu on the Jaty website.</p>
    <p>Jaty may terminate the contract with 14 days’ notice. Jaty may also terminate the contract at any time in the circumstances specified in these General Terms and Conditions and the contract.</p>
    <p>(2) Duration of the contract</p>
    <p>The contract continues until terminated by the Customer or Jaty in accordance with these General Terms and Conditions. Jaty does not currently use paid subscriptions, automatic renewals of paid services or trial subscriptions.</p>
    <p>(3) Cessation of services</p>
    <p>Jaty may discontinue some or all of its services. Jaty will inform the Customer about the planned cessation and its scope at least 14 days in advance.</p>
    <h3>9. Complaints</h3>
    <p>(1) The Customer may submit complaints by email or post to:</p>
    <p>WHIPO sp. z o.o. – Jaty, ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Poland, tax identification number (NIP): 5342666118</p>
    <p>Email: <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a></p>
    <p>(2) A complaint should describe the problem, provide information allowing the Customer’s account to be identified and state the requested resolution.</p>
    <p>The Customer may give Jaty five working days to restore the proper operation of the service. If the problem is not resolved within that period, the Customer may terminate the contract.</p>
    <p>Complaints may concern the operation of the Jaty Service, including individual features. These General Terms and Conditions do not limit the Customer’s rights under mandatory provisions of applicable law.</p>
    <h3> 10. Copyright </h3>
    <p> (1) All rights to the Jaty Website's programs, procedures, software content, technologies, brands, trade names, inventions, materials and any other intellectual property rights that are part of the Jaty Website are vested solely by the Jaty Website. The use of any programs and their content, materials, brands and trade names is allowed only for the purposes indicated in these General Terms and Conditions. Reproduction of programs, benefits, procedures, software, technologies, brands, trade names, inventions and materials belonging to the Jaty Website is prohibited, unless expressly permitted by the Jaty Website. </p>
    <h3> 11. The right to withdraw from the contract, Information on the exercise of the right to withdraw from the contract </h3>
    <p> Information on the exercise of the right of withdrawal </p>
    <p> Right of withdrawal </p>
    <p> The customer has the right to withdraw from the contract within fourteen days without giving any reason. </p>
    <p> The withdrawal period is fourteen days from the date of the conclusion of the contract. </p>
    <p>To withdraw from the contract, send a clear statement of your decision by post to WHIPO sp. z o.o. – Jaty, ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Poland, tax identification number (NIP): 5342666118, or by email to <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. Sending the statement before the withdrawal period expires is sufficient to meet the deadline.</p>
    <p> Consequences of withdrawal </p>
    <p>In the event of withdrawal, the contract is treated as if it had not been concluded and access to the account ends. The <a href="/en/polityka-prywatnosci">privacy policy</a> describes the processing of personal data after use of the service ends.</p>

    <h3> 12. Change of the General Conditions </h3>
    <p> (1) The General Conditions contained in the Regulations may be amended if they do not affect the essential provisions of the contractual relationship and that such a change is necessary in order to adapt issues not provided for at the time of the conclusion of the contract, which would significantly breach the balance of the contractual relationship should they remain unaccounted for. "Essential provisions" are in particular those relating to the type and scope of the contractually agreed services and their duration, including the provisions governing their termination. Further modifications or additions to the Regulations may take place if it is necessary to solve difficulties related to the performance of the contract, caused by gaps arising after the conclusion of the contract. In particular, this may be the case when the legislation is changed and it affects one or more points of the Regulations. </p>
    <p> (2) The specifications for the services may be changed if there is a justified need, provided that these changes do not result in an objectively less favorable situation for the customer (e.g. the need to service or improve the functionality of the website) than it was caused by the specifications of services in force at the time of concluding contract and they do not differ significantly from the previous specifications. A justified need to make changes occurs when technical innovations are available on the market or when third parties, from whom Jaty obtains advanced services necessary for the proper functioning of the website, change the scope of their services. </p>
    <p> (3) The customer must be informed of the changes to the Regulations and the specifications of the services in accordance with paragraph 12. (1) and (2) at least six (6) weeks before their entry into force. Upon their entry into force, the customer should have a special right to terminate the contract. If the customer does not terminate the contract in writing within six (6) weeks of receiving notification of the changes, the changes will become part of the contract when they come into effect. The customer will be expressly notified of this effect via a notification of the changes. </p>
    <p> 13. Others </p>
    <p> (1) Jaty has the right to commission third parties, who are its service providers and contractors, to provide part or all of the scope of the services provided, provided that this does not cause any disadvantages to the client. </p>
    <p> (2) If individual provisions of these Terms and Conditions or the contract are or become invalid, the validity of the remaining provisions shall remain binding on the parties. </p>
    <p> (3) The applicable law in the relationship between the Customer and Jaty's Website is Polish law, subject to the mandatory provisions of the EU Regulation No. 593/2008. </p>
    <p>(4) These General Terms and Conditions do not exclude or limit the Customer’s rights under mandatory provisions of applicable law.</p>
    <p>(5) The owner and operator of the Jaty Service is WHIPO sp. z o.o., a Polish limited liability company with its registered office at ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Poland, tax identification number (NIP): 5342666118.</p>`,

  privacy_policy_content: `<h2> Privacy policy of www.jaty.pl </h2>
    <p> General information </p>
    <p>1. This Privacy Policy sets out the rules for the processing and protection of personal data provided by Users in connection with their use of the dating website services through the Website.</p>
    <p>2. The controller of personal data processed in the Jaty Service is WHIPO sp. z o.o., a Polish limited liability company with its registered office at ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Poland, tax identification number (NIP): 5342666118. For matters concerning personal data, you may contact the controller at this postal address or by email: <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>.</p>
    <p>3. In the interests of the security of the data entrusted to us, we have developed internal procedures and recommendations to prevent disclosure of data to unauthorized persons. We control their performance and constantly check their compliance with the relevant legal acts - the Act on the protection of personal data, the Act on the provision of electronic services, as well as all types of executive acts and Community legislation.</p>
    <p>4. Personal data are processed on the basis of the consent expressed by the User and in cases where the law authorizes the Administrator to process personal data on the basis of legal provisions or to implement the contract concluded between the parties.</p>
    <p>5. The website performs the functions of obtaining information about users and their behavior in the following way: through information entered voluntarily in forms by collecting "cookies" <a href="/en/cookies"> [see cookie policy]. </a></p>
    <p>6. The website collects information voluntarily provided by the user.</p>
    <p>7. The data provided in the form are processed for the purpose resulting from the function of a specific form, e.g. to process the information contact</p>
    <p>8. We do not sell users’ personal data. Data may be processed by providers of tools used to operate and moderate the service, including OpenAI for the AI moderation described below. This does not mean that private messages are published or shared with other users.</p>
    <p>9. The data contained in the form may be viewed by the person who placed it there. This person also has the right to modify and stop processing his data at any time.</p>
    <p>10. We reserve the right to change the privacy policy of the website, which may be affected by development Internet technology, possible changes to the law in the field of personal data protection and the development of our website internet. We will inform you about any changes in a visible and understandable way.</p>
    <p>11. Links to other websites may appear on the Website. Such websites work regardless of the Website and they are not supervised in any way by jaty.pl. These pages may have their own privacy policies and regulations, which we recommend that you read. If in doubt about any of the provisions of this privacy policy, we are available - ours the data can be found in the tab - CONTACT.</p>
    <p>12. The user may at any time request the deletion of all his data related to the account by contacting us via the contact form is available in the customer panel in the "Help Center> Contact us" section, or by contacting us at at <a href="https://jaty.pl/en/kontakt"> https://jaty.pl/en/kontakt </a></p>
    <section id="moderacja-dane" class="content">
    <h3>13. Data used in AI moderation</h3>
    <p>To detect violations of the terms, spam and fraud and to review appeals, Jaty analyses public descriptions, photos, account information, warning history and the content and patterns of sent private messages, including messages retained in the archive. Analysis may include sender and recipient identifiers and sending dates. Private messages are therefore subject to moderation even though they are not publicly visible.</p>
    <p>We use AI tools provided by OpenAI for this analysis. Assessed content and account data may be sent to these tools for moderation. Content may include sensitive information disclosed by a user; accepting the terms does not replace any legally required basis for processing it.</p>
    <p>AI assesses content, context and repeated behaviour under the <a href="/en/regulamin#moderacja">public moderation rules</a>. It can initiate removal of a description or photos, a warning or an account ban without prior human approval of every decision. Ambiguous cases are referred for human assessment. A ban prevents access to the account but does not mean that all data is deleted; a photo removed from a profile is not necessarily removed immediately from all retained copies.</p>
    <p>For review and appeals, we record the assessed content or a reference to it, the reason for the decision, the action and its outcome. Users may express their views, challenge a decision and request reconsideration by a human by emailing <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. Logging in is not required to appeal. Appeals are handled by the operator or an authorised moderator, not solely by AI.</p>
    </section>

    <section id="analityka" class="content">
    <h3>14. Visit statistics and external tools</h3>
    <p>We use Simple Analytics for visit statistics. This measurement is separate from registration data saved with an account. We enable Google Analytics only after analytics consent and rely on consent for this processing. Measurement purposes and provider information about cookies and privacy are described in our <a href="/en/cookies">cookie policy</a>. Using the service or accepting this policy does not constitute consent to optional tracking.</p>
    </section>

    <section id="zrodlo-rejestracji" class="content">
    <h3>15. Registration source information</h3>
    <p>After analytics consent, when an account is created, we may save the first generic page path visited and the source from the utm_source parameter, such as a campaign name. These values are read from the first_page_visited and first_utm_source cookies. This also applies to registration through Facebook.</p>
    <p>The purpose is to understand where people creating accounts come from. This data is linked to an account and is not anonymous. Missing values do not block registration or account features. Source measurement is based on consent (Article 6(1)(a) GDPR). It is optional and is not a condition of entering into an agreement to use the service. Accepting the terms does not replace prior consent to optional cookie storage and access.</p>
    <p>Saved information remains part of the account data after the browser is closed or cookies are deleted. To request access, rectification, erasure or restriction of processing, email <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. These rights apply under the conditions set out in the GDPR. You may also lodge a complaint with the President of the Polish Personal Data Protection Office (UODO).</p>
    </section>`,

  cookies_content: `
    <section class="content">
    <h2>JaTy cookie policy</h2>
    <p>Cookies are small pieces of information stored in your browser. They help keep you signed in and remember your choices, but can also support traffic measurement and advertising. The service operator is WHIPO sp. z o.o., ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Poland, tax identification number (NIP): 5342666118. Contact: <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>.</p>

    <h3>1. Your account and choices</h3>
    <ul>
      <li><strong>Session and security</strong> – session, authentication and form protection cookies, including XSRF-TOKEN. These identify the signed-in user and protect requests to the service. Authentication cookies last up to 365 days; a session may end earlier, for example when you sign out.</li>
      <li><strong>Selected language</strong> – preffered-lang remembers the website language for 365 days after it is saved.</li>
      <li><strong>Dismissing the notification prompt</strong> – notification-box-shown remembers that you dismissed the prompt for 7 days. You grant permission for push notifications separately in your browser.</li>
      <li><strong>Registration link parameter</strong> – free-month may be saved for 1 day after you follow a link with the free_month parameter. This belongs to an older promotional mechanism; it does not activate payments or a subscription.</li>
    </ul>

    <p>We save your consent or refusal as jaty-consent in a cookie and browser local storage (localStorage) for 5 years (1825 days), so we do not ask on every visit. We ask again after expiry, clearing site data or a material change to the scope of consent. Your browser may remove the saved choice earlier.</p>

    <h3>2. Registration source – with analytics consent</h3>
    <p>After analytics consent, the first_page_visited cookie remembers the first page path visited, while first_utm_source remembers the first utm_source value encountered in a link, such as a campaign name. These are session cookies; your browser may retain them when restoring a session.</p>
    <p>During registration, including registration through Facebook, available values are sent to JaTy and saved with the account as the first page visited and the user acquisition source. This measurement is linked to an account and is therefore not an anonymous statistic. It is not needed to create an account, sign in or chat. Deleting browser cookies does not delete information already saved with the account.</p>

    <h3>3. Simple Analytics</h3>
    <p>We use Simple Analytics for aggregate visit statistics. According to its documentation, it uses no cookies or persistent visitor identifiers. Our integration respects Do Not Track (DNT), replaces profile addresses and tokens with generic paths, and disables UTM and referrer metrics. This is separate from the account attribution described above. <a href="https://docs.simpleanalytics.com/privacy" rel="noreferrer">Simple Analytics privacy information</a>.</p>

    <h3>4. Google Analytics – with analytics consent</h3>
    <p>We load Google Analytics only after consent to measure visits and website use. The _ga and _ga_* cookies distinguish browsers and link page views; we set their lifetime to 180 days. Google receives measurement data. We do not send account identifiers, message content or profile names for measurement; we report generic page paths.</p>
    <p>Analytics consent does not include ad personalisation. We do not use Google Ads, AdSense, Hotjar or Facebook Pixel. Facebook sign-in remains a separate function initiated at your request.</p>
    <p>Provider information about cookies and data processing: <a href="https://policies.google.com/technologies/cookies?hl=en" rel="noreferrer">Google cookies</a> and <a href="https://policies.google.com/privacy?hl=en" rel="noreferrer">Google privacy policy</a>.</p>

    <h3>5. Consent and managing data</h3>
    <p>Analytics is off by default. Choose “Accept all”, “Essential only” or your own settings. Analytics consent covers Google Analytics and registration source measurement. Accepting the terms or privacy policy does not replace that consent. An exception applies to operations necessary for transmission or to provide a service requested by the user.</p>
    <p>You can open “Cookie settings” on the cookie policy page or in your account menu at any time and withdraw consent as easily as granting it. We then stop further Google Analytics measurement and source attribution and remove analytics cookies accessible to the service. This does not automatically erase previously collected data or information saved with your account. Withdrawal does not affect the lawfulness of processing before withdrawal.</p>
    <p>Your browser privacy settings let you inspect, delete and block cookies and check their expiry dates. Blocking session and security cookies may prevent sign-in; deleting language preferences may require you to select a language again. Browser settings do not replace the service’s obligation to obtain consent for optional technologies.</p>
    <p>For information about data saved with your account and contacting the controller, see our <a href="/en/polityka-prywatnosci#zrodlo-rejestracji">privacy policy</a>.</p>
    </section>`,

  // shame
  'Normalna': 'Normal',
  'Muskularna': 'Muscular',
  'Lekko puszysta': 'Slightly fluffy',
  'Puszysta': 'Fluffy',
  '120 i mniej': '120 and less',
  '211 i więcej': '211 and more',
  'Posiadam dzieci': 'I have children',
  'Chce mieć': 'I want to have',
  'Jeszcze nie wiem': 'I don\'t know yet',
  'Brązowe (piwne)': 'Brown (hazel)',
  'Niebieskie': 'Blue',
  'Szare': 'Gray',
  'Mieszane': 'Mixed',
  'Panna / Kawaler': 'Miss / Mister',
  'Kawaler': 'Single',
  'Panna': 'Miss',
  'Rozwiedziony': 'Divorced',
  'Rozwiedziona': 'Divorced',
  'Wdowiec': 'Widower',
  'Wdowa': 'Widow',
  'Mam żonę': 'I have a wife',
  'Mam męża': 'I have a husband',
  'Rozwódka / Rozwodnik': 'Divorced',
  'Wdowa / Wdowiec': 'Widow',
  'Separacja': 'Separation',
  'Uczeń / Student': 'Studentg',
  'Emeryt': 'Retired',
  'Rencista': 'Pensioner',
  'Niepracujący': 'Not working',
  'Przedsiębiorca': 'Entrepreneur',
  'Usługi': 'Services',
  'Handel': 'Trade',
  'Pracownik biurowy': 'Office worker',
  'Pracownik fizyczny': 'Manual worker',
  'Służba mundurowa': 'Uniformed Service',
  'Służba zdrowia': 'Healthcare',
  'Edukacja': 'Education',
  'Kierownik / Manager': 'Manager',
  'Dyrektor / Prezes': 'Director / President',
  'Działalność artystyczna': 'Artistic activity',
  'Działalność publiczna': 'Public activity',
  'Marketingowiec / PR\'owiec': ' Marketing / PR',
  'Działalność naukowa': 'Scientific activity',
  'Inne': 'Other',
  'Bardzo chcę małżeństwa': 'I want marriage very much',
  'Dopuszczam myśl o małżeństwie': 'I allow the thought of marriage',
  'Nie chcę małżeństwa': 'I don\'t want marriage',
  'Podstawowe': 'Basic',
  'Średnie': 'Medium',
  'Pomaturalne': 'Medium finished',
  'Licencjat': 'Bachelor',
  'Podyplomowe': 'Postgraduate',
  'Wyższe niepełne': 'Higher incomplete',
  'Wyższe': 'Higher',
  'Katolicyzm': 'Catholicism',
  'Prawosławie': 'Orthodoxy',
  'Protestantyzm': 'Protestantism',
  'Świadek Jechowy': 'Jehovah\'s Witness',
  'Buddyzm': 'Buddhism',
  'Hinduizm': 'Hinduism',
  'Islam': 'Islam',
  'Judaizm': 'Judaism',
  'Ateizm': 'Atheism',
  'Nie chcę mówić': 'I don\'t want to say',
  'Inna': 'Other',

  images: {
    hero: '/portal-randkowy/assets/img/hero_en.webp',
    mobile_jaty: '/portal-randkowy/assets/img/mobile-jaty_en.webp',
    chat: '/portal-randkowy/assets/img/chat_en.webp',
    play_badge: '/en/google/play_badge.png'
  }
}
